import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter, HashRouter, Navigate, Route, Routes } from "react-router";
import { ThemeProvider } from "../provider/ThemeProvider";
import LoadingMask from "./MainPage/NotWorkArea(Side&Head)/LoadingMask";
import CheckMobile from "./lk/CheckMobile";
import { webkcrypt_invoke } from "./TokenProcessing/TokenProcessing";
import webkcrypt_globals from "./dualplug/webkcrypt_globals";
import cadesplugin_api from "./dualplug/cadesplugin_api";
import webkcrypt_create from "./dualplug/webkcrypt";
import { saveDataBD } from "./MainPage/Tools/IndexedBd";
import { getBaseUrl, initRequestTimeout, isEmptyObject, isSessionActive } from "./MainPage/Tools/Tools";
import { useAtom } from "jotai";
import { appConfig, isAuthorized, smetaStore } from "../atoms";
import axios from "axios";
import wrapperStyles from "./wrapper.module.css";
import clsx from "clsx";
import SignInWrapper from "./Singin/SignInWrapper";
import WrapperRightSide from "./MainPage/WrapperMainFile";
import ServerUnavailable from "./ServerUnavailable";

const SignInLK = lazy(() => import("./lk/SignIn")); //вход в лк
const SignUpUmi = lazy(() => import("./lk/SignUp/SignUpUMI")); //регистрация для лк УМИ
const SignUp = lazy(() => import("./lk/SignUp/SignUp")); // стандратная регистрация для ЛК
const RestorePassword = lazy(() => import("./lk/RestorePassword")); //смена пароля только для ЛК уми
const NotFound = lazy(() => import("./NotFound"));

export const theme = React.createContext("");

function showNotif() {
  //отображаем уведомление для янао
  const config = smetaStore.get(appConfig);
  if (config.lk.checkNotifyme === true && config.lk.textContentNotifyme) {
    const div = document.createElement("div");
    const closeDiv = document.createElement("div");
    closeDiv.id = "close";
    closeDiv.onclick = () => {
      div.style.display = "none";
    };
    div.id = "notifyme";
    div.className = "display";
    div.innerHTML = `<p>Уважаемые пользователи!</p>
    ${config.lk.textContentNotifyme}`;
    div.appendChild(closeDiv);
    document.body.appendChild(div);
  }
}

async function logErrorToDatabase(error) {
  const data = [];
  console.log(error);
  const errorObj = {
    filename: error.filename,
    line: error.lineno,
    message: error.message,
  };
  data.push(errorObj);
  await saveDataBD("smeta", "errors", errorObj);
}

const snowActive = () => {
  const snowflakes = document.querySelector(".snowflakes-box");

  const snowball = document.querySelector(".snowball-box");

  return snowflakes && snowball;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function Wrapper() {
  const [config, setConfig] = useAtom(appConfig);
  const [checkedSession, setCheckedSession] = useState(false);
  const [loadConfig, setLoadConfig] = useState(true);
  const [isServerUnavailable, setIsServerUnavailable] = useState(false);
  const [isSessionAuthorized, setIsAutorized] = useAtom(isAuthorized);

  const checkSessionActive = async () => {
    const sessionInfo = await isSessionActive();
    const licGUID = sessionInfo.licGUID;
    if (licGUID) {
      sessionStorage.setItem("LicG", licGUID);
    }
    if (!sessionInfo.active) {
      localStorage.setItem("login", "");
    }
    setIsAutorized(sessionInfo.active);
    setCheckedSession(true);
  };

  const uploadConfig = async () => {
    try {
      const baseUrl = getBaseUrl();
      const response = await axios.get(`${baseUrl}config.json?time=${Date.now()}`, { timeout: initRequestTimeout });
      const responseConfig = response.data;
      if (typeof responseConfig === "object" && !isEmptyObject(responseConfig)) {
        const {
          smeta: { multiSession },
        } = responseConfig;
        const finalConfig = {
          ...responseConfig,
          smeta: {
            ...responseConfig.smeta,
            stimateVersion: config.smeta.stimateVersion,
            multiSession: multiSession === undefined ? true : multiSession,
          },
        };
        setConfig(finalConfig);
        return finalConfig;
      }
    } catch (error) {
      console.warn(error.message);
    } finally {
      setLoadConfig(false);
    }
  };

  const initializeSession = async () => {
    setIsServerUnavailable(false);
    const config = await uploadConfig();
    try {
      await checkSessionActive();
    } catch (error) {
      // Сервер не ответил: показываем кнопку «Повторить», а не бесконечную загрузку.
      console.warn(error);
      setIsServerUnavailable(true);
      return;
    }
    if (!snowActive() && config)
      new Snow({
        showSnowBalls: config.lk.baseUmi !== "1",
      });
  };

  const smetaWebInitialization = async () => {
    webkcrypt_globals();
    cadesplugin_api();
    webkcrypt_create();
    await initializeSession();
    window.addEventListener("error", logErrorToDatabase);
  };

  useEffect(() => {
    smetaWebInitialization();
    return () => {
      window.removeEventListener("error", logErrorToDatabase);
    };
  }, []);

  String.prototype.replaceAt = function (index, replacement) {
    return this.substring(0, index) + replacement + this.substring(index + replacement.length);
  };

  function detectMob() {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  window.onload = function () {
    webkcrypt_invoke("webkcrypt-check-updates", null, (event) => {
      // nothing
    });
    showNotif();
  };
  if (isServerUnavailable) {
    return (
      <main className={clsx(wrapperStyles.main)}>
        <ServerUnavailable onRetry={initializeSession} />
      </main>
    );
  }
  if (!checkedSession || loadConfig) return <LoadingMask />;
  if (config && config.lk && config.lk.baseUmi !== "1" && detectMob() && window.innerWidth < 650) {
    return <CheckMobile />;
  } else {
    const routes = (
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<LoadingMask />}>
              {config.smeta.hideEnter !== undefined && config.smeta.hideEnter === true ? (
                <SignInLK />
              ) : (
                <SignInWrapper />
              )}
            </Suspense>
          }
        />
        {config.smeta.hideEnter !== true && (
          <Route
            path="/lk"
            element={
              <Suspense fallback={<LoadingMask />}>
                <SignInLK />
              </Suspense>
            }
          />
        )}
        {config.lk.baseUmi === "1" && (
          <Route
            path="/restorepassword"
            element={
              <Suspense fallback={<LoadingMask />}>
                <RestorePassword />
              </Suspense>
            }
          />
        )}
        <Route
          path="/signup"
          element={
            <Suspense fallback={<LoadingMask />}>{config.lk.baseUmi === "1" ? <SignUpUmi /> : <SignUp />}</Suspense>
          }
        />
        <Route
          path="/main"
          element={
            isSessionAuthorized ? (
              <ThemeProvider>
                <WrapperRightSide />
              </ThemeProvider>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="*"
          element={
            <ThemeProvider>
              <Suspense fallback={<LoadingMask />}>
                <NotFound />
              </Suspense>
            </ThemeProvider>
          }
        />
      </Routes>
    );
    return (
      <main className={clsx(wrapperStyles.main)}>
        {config.smeta.basename && config.smeta.basename !== "«»" ? (
          <BrowserRouter basename={config.smeta.basename}>{routes}</BrowserRouter>
        ) : (
          <HashRouter>{routes}</HashRouter>
        )}
      </main>
    );
  }
}
